import { render, staticRenderFns } from "./NewBookingAddressForm.vue?vue&type=template&id=648b7f1e&"
import script from "./NewBookingAddressForm.vue?vue&type=script&lang=js&"
export * from "./NewBookingAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports